<script setup lang="ts">
    const props = defineProps({
        collapsed: {
            type: Boolean,
            required: false,
        },
    });

    const { $tracker } = useNuxtApp();

    // Unpaid level 4 (TDD-5603): global search stays visible but disabled.
    const { isBlocked } = useUnpaidStatus();

    const openSearch = () => {
        if (isBlocked.value) {
            useUnpaidTracking().track('unpaid_locked_item_clicked', { module: 'search' });
            return;
        }

        $tracker.track('sidebar_search_clicked');
        useEvent('app:search:open');
    };
</script>

<template>
    <button
        class="relative mx-2 gap-2 mt-3 items-center hidden text-sm text-white transition-all rounded-md md:flex dark:text-gray-400 md:py-2 md:px-4 border border-branding-white/30"
        :class="isBlocked ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer hover:bg-branding-white/10 dark:hover:text-gray-200 dark:bg-black dark:hover:bg-blue-900'"
        :disabled="isBlocked"
        @click.prevent="openSearch"
    >
        <i class="text-xs fa-regular fa-search" />
        <span v-if="!collapsed">
            {{ $t('global_search.label') }}
        </span>
        <span
            v-if="!collapsed"
            class="ml-auto pl-4 text-gray-400"
        >
            ⌘K
        </span>
    </button>
</template>
